import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { parseCalculator, sumParts } from "../domain";
// Buttons avoid Android's pen/keyboard-specific editable-field behaviour.
export function CountInput({ label, value, onChange, calculator = false }) {
    const [open, setOpen] = useState(false);
    let total = "—";
    try {
        if (value)
            total = String(sumParts(parseCalculator(value)));
    }
    catch {
        total = "Finish entry";
    }
    return _jsxs("div", { className: "touch-count", children: [_jsx("span", { children: label }), _jsx("button", { type: "button", className: "count-display", "aria-label": label, "aria-expanded": open, onClick: () => setOpen(!open), children: value || "Tap to enter" }), open && _jsxs("div", { className: "count-pad", role: "group", "aria-label": label + " keypad", children: [_jsxs("div", { className: "pad-total", "aria-live": "polite", children: [calculator ? "Total" : "Quantity", ": ", total] }), _jsx("div", { className: "pad-keys", children: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "Backspace", "0", calculator ? "+" : "Clear"].map(key => _jsx("button", { type: "button", "aria-label": key, onClick: () => {
                                if (key === "Backspace")
                                    onChange(value.trimEnd().slice(0, -1).trimEnd());
                                else if (key === "Clear")
                                    onChange("");
                                else if (key === "+") {
                                    if (/\d$/.test(value))
                                        onChange(value + " + ");
                                }
                                else if (value.length < 2000)
                                    onChange(value + key);
                            }, children: key === "Backspace" ? "⌫" : key }, key)) }), _jsxs("button", { type: "button", onClick: () => setOpen(false), children: ["Done entering ", label] })] })] });
}
